export default {
      id: "icon-egalite-pride-usage",
      viewBox: "0 0 113.6 113.6",
      url: __webpack_public_path__ + "icons.svg#icon-egalite-pride",
      toString: function () {
        return this.url;
      }
    }